import FAQ, { type IQuestion } from "@core-components/faq/FAQ";
import useAppTranslation from "@hooks/language/useAppTranslation";
import type React from "react";
import ValorantGradientText from "../ValorantGradientText";

const ValorantFAQ: React.FC = () => {
  const { t } = useAppTranslation("pages.valorant.faq");
  const questions = t("questions", { returnObjects: true }) as IQuestion[];

  const formattedQuestions = questions.map((q, index) => {
    if (index === 1 || index === 8) {
      return { ...q, className: "reset-tailwind" };
    }
    return q;
  });

  return (
    <FAQ TextGradient={ValorantGradientText} questions={formattedQuestions} />
  );
};

export default ValorantFAQ;
